export default {
  badge: {
    APPROVAL_PENDING: '#F59E0B',
    PENDING: '#F59E0B',
    APPROVED: '#22C55E',
    VERIFIED: '#22C55E',
    REJECTED: '#EF4444',
    FAIL: '#EF4444',
    SHORT: '#F97316',
    LONG: '#14B8A6',
    SELL: '#EF4444',
    BUY: '#22C55E',
    CLOSE: '#EF4444',
    OPEN: '#22C55E',
    ENABLED: '#22C55E',
    ACTIVE: '#22C55E',
    DISABLED: '#EF4444',
    SUCCESS_DETAIL: '#64748B',
    structured_product_status: {
      'pre-launch': '#A855F7',
      opening: '#3B82F6',
      collecting: '#22C55E',
      closed: '#F59E0B'
    }
  }
}
